import { render, staticRenderFns } from "./Criteria.vue?vue&type=template&id=3030d373&scoped=true"
import script from "./Criteria.vue?vue&type=script&lang=js"
export * from "./Criteria.vue?vue&type=script&lang=js"
import style0 from "./Criteria.vue?vue&type=style&index=0&id=3030d373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3030d373",
  null
  
)

export default component.exports